import styled from "styled-components";
import {JackpotToastTimeAndAmountDefaultBox} from "./jackpot-toast-time-and-amount.default.box";

export const JackpotToastTimeAndAmountMrGreenBox = styled(JackpotToastTimeAndAmountDefaultBox)`
    border-radius: 30px;
    background-color: ${props => props.theme.colors.backgroundLight};
    background: linear-gradient(90deg, ${props => props.theme.colors.backgroundDark}, ${props => props.theme.colors.backgroundLight}, ${props => props.theme.colors.backgroundLight}, ${props => props.theme.colors.backgroundDark});
    box-shadow: 0px 2px 8px 0px ${props => props.theme.colors.backgroundDark},
        inset 0px -1px 10px 0px ${props => props.theme.colors.brandSecondary};
    border: 1px solid ${props => props.theme.colors.brandSecondary};
`;